var map = {
	"./afrarchcologne.webp": 8659,
	"./antikzeichnung.jpg": 691,
	"./arapacis.jpg": 7196,
	"./ariadne.jpg": 7118,
	"./databasepausanias.jpg": 2325,
	"./fotothekmuenchen.jpg": 2654,
	"./fotothekrom.webp": 518,
	"./grako.jpg": 4581,
	"./hellespont.jpg": 2564,
	"./hinkel.webp": 8353,
	"./rakob.webp": 4775,
	"./rezeptionantike.jpg": 6052,
	"./syrher.webp": 5259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2768;